import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import useDeviceType from "../common/useDeviceType";

const Review = () => {
  const isMobile = useDeviceType();

  const reviewList = [
    {
      src: "/images/review1.png",
      txt: `<sapn>
당일에 급하게 문의드렸는데도 불구하고
바로 방문해주셔서 정말 감사했습니다.
      </sapn>`,
    },
    {
      src: "/images/review2.png",
      txt: `<sapn>
      시골집을 정리하기 위해 문의를 드렸는데
꽤 먼거리임에도 금방 와주셨고 견적도 나름 괜찮게 받은 것 같아 만족스러웠습니다.
      </sapn>`,
    },
    {
      src: "/images/review3.png",
      txt: `<sapn>
      각종 폐기물들이 많이 쌓여 정리요청을 드렸는데 가격도 저렴하고 속도도 빨라 굉장히 만족스러웠습니다.
      </sapn>`,
    },
    {
      src: "/images/review4.png",
      txt: `<sapn>
      처음 문의드릴땐 참 막막했는데 여러모로 많이 도움주셔서 정말 감사해요~
      </sapn>`,
    },
    {
      src: "/images/review5.png",
      txt: `<sapn>
      부모님이 요양병원에 입원하시게 되어 문의를 드렸는데 비대면으로 진행했음에도 불편함 없이 잘 해결해주셨어요
      </sapn>`,
    },
    {
      src: "/images/review6.png",
      txt: `<sapn>
      이민정리 요청을 드렸는데 확실히 전문가에게 맡기니 일이 척척 빠르게 진행되더라구요
      </sapn>`,
    },
    {
      src: "/images/review7.png",
      txt: `<sapn>
      고독사청소 현장을 문의했는데 .. 정말 아무나 할 수 없는 일을 알아서 해주시니 감사할 따름이었습니다.
      </sapn>`,
    },
    {
      src: "/images/review8.png",
      txt: `<sapn>
      시골에 있는 어머님집을 정리하려고 문의했는데 확실히 전문가셔서 알아서 딱 견적내서 해주시더라구요 마무리도 정말 만족스러웠습니다
      </sapn>`,
    },
    {
      src: "/images/review9.png",
      txt: `<sapn>
      처음엔 엄청 비용이 크게나올까봐 걱정이 많았는데 작업에 들어가는 견적만 딱 산출해주셔서 만족스럽게 진행했습니다.
      </sapn>`,
    },
    {
      src: "/images/review10.png",
      txt: `<sapn>
      정말 감사해요~ 다음번에 문의드릴 일이 있다면 꼭 다시 연락드릴게요~
      </sapn>`,
    },
  ];

  return (
    <section id="best" className="relative w-full overflow-hidden bg-[#fd6f22] py-14 lg:pb-0 lg:pt-28 xl:pt-36">
      <div className="relative mx-auto px-[calc((100%-var(--container))/4)] ">
        {/* Left: logo + woman photo */}
        <img
          src={"/images/whiteFavicon.png"}
          alt="바우하우스 로고"
          className="absolute left-[calc((100%-var(--container))/4)] -top-32 h-16 w-auto brightness-0 invert md:h-20 lg:h-36"
        />
        <div className="relative lg:grid grid-cols-4 gap-5">
          <div className="relative mx-auto w-full max-w-xs shrink-0 lg:mr-0 lg:w-[320px] hidden lg:grid items-end">
            <img
              // data-aos="fade-right"
              src={"/images/bannerIcon2.png"}
              alt="바우하우스 상담원"
              className="h-fit w-auto object-contain mt-auto"
            />
          </div>

          {/* Right: copy + review cards */}
          <div className="col-span-3">
            <p className="text-white/90 text-lg xl:text-xl">바우하우스와 함께해주셔서 감사합니다</p>
            <h2 className="text-white leading-tight">
              <span className="font-light">바우하우스</span> <span className="text-[#FCEACB]">BEST 리뷰</span>
            </h2>
            <p className="mt-3 text-white/90 text-lg xl:text-xl">
              바우하우스를 실제로 이용해보신 고객님들의 실제 리뷰를 공개합니다
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <h3 className="rounded-full bg-white px-4 py-1 font-light text-[#fd6f22]">특별한 혜택</h3>
              <h3 className="font-bold text-white xl:text-3xl">
                <span className="font-light">블로그 포스팅하고</span> <span className="text-[#FCEACB]">할인받자!</span>
              </h3>
            </div>
            <p className="mt-3 leading-relaxed text-white/90 text-lg xl:text-xl">
              작업 진행 후 작업관련 내용이 포함된 블로그 포스팅을 고객님 블로그에 올려주세요!
              <br />
              바우하우스에 링크를 공유해주시면 10,000원 상당의 커피 쿠폰을 보내드립니다
            </p>

            {/* Scrollable review cards */}
            <div data-aos="fade-left" className="mt-8 mb-2">
              <Swiper
                spaceBetween={10}
                // centeredSlides={true}
                loop
                slidesPerView={isMobile ? 2 : 5}
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                className=" relative w-full h-full"
              >
                {reviewList.map((v, i) => (
                  <SwiperSlide key={i} className="overflow-hidden rounded-sm bg-white relative w-full h-full p-2">
                    <div className=" relative w-full h-full">
                      <div className=" relative w-full h-16">
                        <p className="text-black text-xs" dangerouslySetInnerHTML={{ __html: v.txt }}></p>
                      </div>
                      <div className="relative w-full h-fit mt-2 mb-1 mx-auto /animate-bounce ">
                        <img
                          src="/images/iconStar.png"
                          alt="star"
                          className=" relative w-auto h-full max-h-5 object-contain"
                        />
                      </div>
                      <div className="relative w-full h-[calc(100%-40px)] bg-white shadow-md">
                        <img className="relative w-full h-auto object-cover object-center" src={v.src} alt="review" />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Review;
